module.exports = __webpack_public_path__ + "static/media/15PerformancePhotos.b8c9b6f7.jpeg";